<app-page-header 
    title="Personnels" 
    [buttons]="[{
        name: 'Add',
        eventName: 'add',
        cssClass: 'bg-primary'
    }]"
    (onButtonClick)="action($event)">
</app-page-header>
<app-page-content>
    <app-data-grid [dataSource]="dataSource" [config]="config" [dataLength]="dataSource.length" [isLoading]="isLoading"
        (dataActionEvent)="action($event)">
    </app-data-grid>
</app-page-content>

<app-slide-panel [(visible)]="editPanel">
</app-slide-panel>